<template>
<div>
	<h3>Project Labour Report</h3>

	<div style="overflow-x: auto;">
		<labour-report-table v-model="labourReportGroups"></labour-report-table>
	</div>

	<div v-if="$store.project && $store.project.detailed_timelogs == 1">
		<h3>Detailed Logs (depth: {{ $store.project.detailed_timelogs_depth }})</h3>

		<div v-if="$store.project.detailed_timelogs_depth == 0">

			<template v-for="comp in nestedBidWithDetailedClaims" >
				<h4>{{ comp.name }}</h4>
				<labour-report-table :value="groupifyComponentClaims(comp.timeLogDetailedClaims,comp,false)"></labour-report-table>
			</template>

		</div>

		<accordion v-else-if="$store.project.detailed_timelogs_depth == 1"
			v-for="(compCat,index) in nestedBidWithDetailedClaims"
			:heading="compCat.name"
			:key="'accordion_' + index">

			<template v-for="comp in compCat.JobBidComponent" >
				<h4>{{ comp.item_number }}: {{ comp.name }}</h4>

				<labour-report-table :value="groupifyComponentClaims(getComponentDetailedClaims(comp, timeLogs), comp, false)"></labour-report-table>
			</template>

		</accordion>

		<accordion v-if="hasChangeOrders" heading="Change Orders">

			<template v-for="co in changeOrders">
				<h4>CO-{{ $store.project.job_num }}-{{ co.quote_num }}</h4>
				<labour-report-table :value="groupifyComponentClaims(getChangeOrderDetailedClaims(co.id,timeLogs),co,true)"></labour-report-table>
			</template>
			
		</accordion>
		
	</div>
</div>
</template>
<script type="text/javascript">
import TableList from "@/components/TableList"
import Accordion from "@/components/Accordion"

import LabourReportTable from "@/components/LabourReportTable"

import JobMixins from "@/mixins/JobMixins.js"
import ProjectBidMixins from "@/mixins/ProjectBidMixins.js"

export default {
	name: "LabourReport",
	mixins: [JobMixins,ProjectBidMixins],
	components: {
		TableList,
		Accordion,
		LabourReportTable
	},
	mixins: [ProjectBidMixins],
	data() {
		return {
			classificationsInEstimate: [],
			timeLogs: [],
			timeLogFetchProgress: 0,
			timeLogFetchCompleted: false,
			dataFetched: false,
			bid: null,
			changeOrders: [],
			chargeOutGroups: [],
			labourReportGroups: [],
			detailedClaimsReport: null,
			hourTypeLabelMap: {
				regular_hours: "Reg",
				overtime_hours_15x: "1.5x OT",
				overtime_hours_2x: "2x OT",
				overtime_hours_25x: "2.5x OT"
			}
		}
	},
	watch: {
		'$store.project'() {
			//if (!this.dataFetched && this.reportNeedsFetching())
				this.fetchData()
		}
	},
	computed: {
		fields() {
			let fields = [
				{label: 'Classification',key:'lineLabel'},
				//{label: "Hours Type",key:'hourType'},
				{label: 'Estimated Hours',key:'estimatedHrs',align:"right"},
				{label: 'Hrs to Date',key:'actualHrs',align:"right"},
				{label: 'Estimated Cost',key:'costAllowed',align:"right"},
				{label: 'Actual Cost',key:'actualCost',align:"right"},
				{label: '% Complete',key:'percentComplete',align:"right"},
				{label: 'Over/Under',key:'overUnder',align:"right"},
			]

			return fields
		},
		changeOrderDetailedClaims() {

			return this
		},
		hasChangeOrders() {
			let logWithChangeOrder = this.timeLogs.find(log => {
				if ("TimeLogDetailedClaim" in log && log.TimeLogDetailedClaim) {
					let found = log.TimeLogDetailedClaim.find(claim => claim.change_quote_id > 0)
					if (found)
						return true
				}
			})
			return logWithChangeOrder ? true : false
		},
		nestedBidWithDetailedClaims() {
			let vm = this

			let mutated = []

			this.bidComponentsNested.forEach(cat => {
				let mutatedCat = vm.cloneObj(cat)

				mutatedCat.timeLogDetailedClaims = []
				vm.timeLogs.forEach(log => {

					if ("TimeLogDetailedClaim" in log && log.TimeLogDetailedClaim) {
						log.TimeLogDetailedClaim
							.filter(claim => claim.job_bid_component_id == cat.id)
							.forEach(claim => {
								if (!("timeLogDetailedClaims" in mutatedCat) || !mutatedCat.timeLogDetailedClaims)
									mutatedCat.timeLogDetailedClaims = []

								mutatedCat.timeLogDetailedClaims.push(claim)
							})
					}
					return true
				})

				mutated.push(mutatedCat)
			})


			return mutated
		}
	},
	methods: {
		findNestedComponentNodeById(list, id) {
			if (!list) return null;

			let match = null
			list.forEach(component => {
				if (component.id == id) 
					match = component
			})
			if (match)
				return match
			else {
				list.forEach(component => {
					let kids = component.JobBidComponent || [];
					let found = this.findNestedComponentNodeById(kids,id)
					if (found) {
						match = found
					}
				})
			}
			return match
		},
		findClassificationEstimated(flattenedLabourBidElements,classificationId,bidComponentId) {
			
			return flattenedLabourBidElements.find(element => {
				if (bidComponentId) {
					if (element.parsedFields.classification_id == classificationId) {
						if (bidComponentId == element.bid_component_id)
							return true
						else if (("JobBidComponent" in element && element.JobBidComponent && bidComponentId == element.JobBidComponent.bid_component_id))
							return true
					}

					return false
				}
				else
					return element.parsedFields.classification_id == classificationId
			})
		},
		sumClassificationHoursOnComponent(component, classificationId) {
			return this._sumHrsRecursive(component, classificationId);
		},

		_sumHrsRecursive(node, classificationId) {

			if (!node) return 0;

			let total = 0;

			// 1) sum labour directly on this node
			let objs = node.JobBidComponentObject || [];

			objs
				.filter(obj => obj.type == "EmployeeClassification")
				.forEach(obj => {
					let parsedFields = {};
					try {
						parsedFields = JSON.parse(obj.field_values_json);
					} catch (e) {}

					if (parsedFields.classification_id == classificationId) {
						total += +parsedFields.hrs || 0;
					}
				});

			// 2) recurse into children (NO scaling)
			let kids = node.JobBidComponent || [];
			for (let i = 0; i < kids.length; i++) {
				total += this._sumHrsRecursive(kids[i], classificationId);
			}

			// ❌ NO MULTIPLICATION BY node.qty
			return total;
		},
		sumClassificationCostOnComponent(component, classificationId) {
			return this._sumCostRecursive(component, classificationId);
		},

		_sumCostRecursive(node, classificationId) {

			if (!node) return 0;

			// 1) sum this node's Labour objects matching the classification
			var ownCost = 0;
			var objs = node.JobBidComponentObject || [];

			objs.filter(obj => obj.type == "EmployeeClassification").forEach(obj => {
				let parsedFields = JSON.parse(obj.field_values_json)

				if (parsedFields.classification_id == classificationId) {
					if ("totalBaseRaw" in parsedFields)
						ownCost += parsedFields.totalBaseRaw
					else if ("hrs" in parsedFields && "rate" in parsedFields) 
						ownCost += +parsedFields.qty * +parsedFields.rate
				}
			})

			// 2) recurse into children components
			var kids = node.JobBidComponent || [];
			for (var k = 0; k < kids.length; k++) {
			  ownCost += this._sumCostRecursive(kids[k], classificationId);
			}

			// 3) multiply the total from this subtree by this node's qty
			var mult = 1;
			if (node.qty != null && node.qty !== "") {
			  var q = +node.qty;
			  if (!isNaN(q)) mult = q; // allow 0 if your data uses it to zero-out
			}

			return ownCost * mult;
		},
		calcClassificationEstimatedCost(classificationId,bidComponentId) {
			let classificationEstimatedCost = 0

			let component = this.findNestedComponentNodeById(this.bidComponentsNested, bidComponentId)

			classificationEstimatedCost = this.sumClassificationCostOnComponent(component,classificationId)

			return classificationEstimatedCost
		},
		calcClassificationEstimatedHours(classificationId,bidComponentId) {
			let classificationEstimatedHrs = 0

			let component = this.findNestedComponentNodeById(this.bidComponentsNested, bidComponentId)

			classificationEstimatedHrs = this.sumClassificationHoursOnComponent(component,classificationId)

			return classificationEstimatedHrs
		},
		renderGroupReportItem(group,classification, log, classificationEstimatedCost, classificationEstimatedHrs) {

			let logHoursTotal = 0
			if (log)
				logHoursTotal = +log.regular_hours + +log.overtime_hours_15x + +log.overtime_hours_2x + +log.overtime_hours_25x

			if (!group) {

			}

			if (!classification) {
				classification = {
					id: 'Unclassified',
					title: "Unclassified"
				}
			}

			return {
				id: group.id,
				label: group.label,
				estimatedHrs: classificationEstimatedHrs,
				hrsToDateTotal: logHoursTotal,
				estimatedCost: classificationEstimatedCost,
				actualCost: log ? log.calculated_cost : 0,
				percentComplete: log ? +log.calculated_cost / classificationEstimatedCost : 0,
				overUnder: log ? classificationEstimatedCost - +log.calculated_cost : classificationEstimatedCost,
				classifications: [{
					id: classification.id,
					title: classification.title,
					estimatedHrs: classificationEstimatedHrs,
					hrsToDateTotal: logHoursTotal,
					estimatedCost: classificationEstimatedCost,
					actualCost: log ? log.calculated_cost : 0,
					percentComplete: log ? +log.calculated_cost / classificationEstimatedCost : 0,
					overUnder: log ? classificationEstimatedCost - +log.calculated_cost : classificationEstimatedCost,
					hrsToDate: {
						regular_hours: log ? +log.regular_hours : 0,
						overtime_hours_15x: log ? +log.overtime_hours_15x : 0,
						overtime_hours_2x: log ? +log.overtime_hours_2x : 0,
						overtime_hours_25x: log ? +log.overtime_hours_25x : 0,
					}
				}],
				classificationsVisible: false
			}
		},
		renderChargeOutGroupsFromBid() {
			var vm = this;
			var labourReportGroups = [];

			var flattenedLabourBidElements = this.flattenedRecordsFromNested('labour');

			flattenedLabourBidElements.forEach(cl => {

				var theGroup = null;
				var theClassification = null;

				// 1) Try to resolve group directly from flattened record
				if ("group_id" in cl && cl.group_id) {
					theGroup = vm.chargeOutGroups.find(group => group.id == cl.group_id);
				}

				// 2) Otherwise resolve from EmployeeClassification list -> group_id
				if (!theGroup) {
					if (vm.$store && vm.$store.employeeClassifications && cl.parsedFields && cl.parsedFields.classification_id) {

						theClassification = vm.$store.employeeClassifications.find(clFromList => clFromList.id == cl.parsedFields.classification_id);

						if (theClassification && theClassification.group_id) {
							theGroup = vm.chargeOutGroups.find(group => group.id == theClassification.group_id);
						}
					}
				}

				if (!theGroup) {
					theGroup = { id: 'ungrouped', label: 'Ungrouped' };
				}

				var classificationEstimatedCost = (+cl.hrs) * (+cl.rate);
				var classificationEstimatedHrs = (+cl.hrs);

				var existingGroupIndex = labourReportGroups.findIndex(g => g.id == theGroup.id);

				if (existingGroupIndex >= 0) {

					// merge into existing group
					var group = labourReportGroups[existingGroupIndex];

					var classificationId = theClassification && theClassification.id
						? theClassification.id
						: 'Unclassified';

					var classificationTitle = theClassification && theClassification.title
						? theClassification.title
						: 'Unclassified';

					var existingClIndex = group.classifications.findIndex(c => c.id == classificationId);

					if (existingClIndex >= 0) {

						// merge into existing classification
						var clRow = group.classifications[existingClIndex];

						clRow.estimatedHrs += classificationEstimatedHrs;
						clRow.estimatedCost += classificationEstimatedCost;
						clRow.overUnder += classificationEstimatedCost;

					} else {

						// create new classification row
						group.classifications.push({
							id: classificationId,
							title: classificationTitle,
							estimatedHrs: classificationEstimatedHrs,
							hrsToDateTotal: 0,
							estimatedCost: classificationEstimatedCost,
							actualCost: 0,
							percentComplete: 0,
							overUnder: classificationEstimatedCost,
							hrsToDate: {
								regular_hours: 0,
								overtime_hours_15x: 0,
								overtime_hours_2x: 0,
								overtime_hours_25x: 0,
							}
						});
					}

				} else {

					// create new group
					labourReportGroups.push(
						vm.renderGroupReportItem(
							theGroup,
							theClassification,
							false,
							classificationEstimatedCost,
							classificationEstimatedHrs
						)
					);
				}

			});

			// --- existing time log merge logic continues below (leave as-is) ---
			vm.timeLogs.forEach(log => {

				var logHoursTotal = (+log.regular_hours) + (+log.overtime_hours_15x) + (+log.overtime_hours_2x) + (+log.overtime_hours_25x);

				var classification = false;
				try {
					classification = JSON.parse(log.classification_json);
				}
				catch (e) {}

				if (classification) {

					//find group this classification belongs to
					var groupIndex = labourReportGroups.findIndex(group => group.id == classification.group_id);

					var classificationEstimatedCost = 0; // this.calcClassificationEstimatedCost(classification.id)

					var classificationCompiled = flattenedLabourBidElements.find(bidCl => {
						// match on id if possible
						if (bidCl && bidCl.parsedFields && bidCl.parsedFields.classification_id)
							return bidCl.parsedFields.classification_id == classification.id;
						return false;
					});

					if (classificationCompiled) {
						classificationEstimatedCost = (+classificationCompiled.hrs) * (+classificationCompiled.rate);
					}

					if (groupIndex >= 0) {
						var group = labourReportGroups[groupIndex];
						var cl = group.classifications.find(c => c.id == (classification.id || 'Unclassified'));

						if (cl) {
							cl.hrsToDateTotal += logHoursTotal;
							cl.hrsToDate.regular_hours += +log.regular_hours;
							cl.hrsToDate.overtime_hours_15x += +log.overtime_hours_15x;
							cl.hrsToDate.overtime_hours_2x += +log.overtime_hours_2x;
							cl.hrsToDate.overtime_hours_25x += +log.overtime_hours_25x;
							cl.actualCost = (+cl.actualCost) + (+log.calculated_cost);
							cl.percentComplete = classificationEstimatedCost > 0 ? cl.actualCost / classificationEstimatedCost : 0;
							cl.overUnder = classificationEstimatedCost - cl.actualCost;
							group.hrsToDateTotal = (group.hrsToDateTotal || 0) + logHoursTotal;
							group.actualCost = (group.actualCost || 0) + (+log.calculated_cost);
						} else {
							// Classification has time logged but wasn't in the bid for this group
							group.classifications.push({
								id: classification.id != null && classification.id !== '' ? classification.id : 'Unclassified',
								title: (classification.title != null && classification.title !== '') ? classification.title : 'Unclassified',
								estimatedHrs: 0,
								hrsToDateTotal: logHoursTotal,
								estimatedCost: classificationEstimatedCost,
								actualCost: +log.calculated_cost,
								percentComplete: classificationEstimatedCost > 0 ? (+log.calculated_cost) / classificationEstimatedCost : 0,
								overUnder: classificationEstimatedCost - (+log.calculated_cost),
								hrsToDate: { regular_hours: +log.regular_hours, overtime_hours_15x: +log.overtime_hours_15x, overtime_hours_2x: +log.overtime_hours_2x, overtime_hours_25x: +log.overtime_hours_25x }
							});
							group.hrsToDateTotal = (group.hrsToDateTotal || 0) + logHoursTotal;
							group.actualCost = (group.actualCost || 0) + (+log.calculated_cost);
						}
					} else {
						// Group not in report (no bid labour for this group) — add group so hrs show
						var theGroup = vm.chargeOutGroups.find(g => g.id == classification.group_id);
						if (theGroup) {
							labourReportGroups.push({
								id: theGroup.id,
								label: theGroup.label,
								estimatedHrs: 0,
								hrsToDateTotal: logHoursTotal,
								estimatedCost: classificationEstimatedCost,
								actualCost: +log.calculated_cost,
								percentComplete: 0,
								overUnder: classificationEstimatedCost - (+log.calculated_cost),
								classifications: [{
									id: classification.id != null && classification.id !== '' ? classification.id : 'Unclassified',
									title: (classification.title != null && classification.title !== '') ? classification.title : 'Unclassified',
									estimatedHrs: 0,
									hrsToDateTotal: logHoursTotal,
									estimatedCost: classificationEstimatedCost,
									actualCost: +log.calculated_cost,
									percentComplete: classificationEstimatedCost > 0 ? (+log.calculated_cost) / classificationEstimatedCost : 0,
									overUnder: classificationEstimatedCost - (+log.calculated_cost),
									hrsToDate: { regular_hours: +log.regular_hours, overtime_hours_15x: +log.overtime_hours_15x, overtime_hours_2x: +log.overtime_hours_2x, overtime_hours_25x: +log.overtime_hours_25x }
								}],
								classificationsVisible: false
							});
						}
					}
				}
			});

			// Finalize group totals (keep your existing code)
			this.labourReportGroups = labourReportGroups.map(group => {
				group.estimatedCost = group.classifications.reduce((acc, cl) => cl.estimatedCost + acc, 0);
				group.estimatedHrs = group.classifications.reduce((acc, cl) => cl.estimatedHrs + acc, 0);

				group.percentComplete = 0
				if (+group.estimatedCost > 0 && +group.actualCost > 0) {
					// `renderInlineProgressBar` expects 0-100
					group.percentComplete = (+group.actualCost) / (+group.estimatedCost) * 100
				}

				// Ensure group rollups reflect actuals (was previously left stale)
				group.overUnder = (+group.estimatedCost) - (+group.actualCost || 0)
				return group;
			});
		},
		getTotalElementsOnChangeOrder(co,elementType) {
			let elements = [], vm = this, childElements = []

			if ("JobChangeOrderObject" in co && co.JobChangeOrderObject) {
				co.JobChangeOrderObject
					.filter(el => el.type == elementType || !elementType)
					.forEach(el => {
						let mutatedEl = vm.cloneObj(el)

						let parsedFields = {}
						try {
							parsedFields = JSON.parse(el.field_values_json)
						}
						catch (e) {}

						mutatedEl.parsedFields = parsedFields

						mutatedEl.qty = +mutatedEl.qty * +co.qty

						elements.push(mutatedEl)
					})
			}
			return elements
		},
		getComponentDetailedClaims(component,logs) {
			let claims = []

			if (logs) {
				logs.forEach(log => {
					if ("TimeLogDetailedClaim" in log && log.TimeLogDetailedClaim) {
						claims = [
							...claims,
							...log.TimeLogDetailedClaim.filter(claim => claim.job_bid_component_id == component.id)
						]
					}
				})
			}

			return claims
		},
		getChangeOrderDetailedClaims(changeOrderId, logs) {
			let claims = []

			if (logs) {
				logs.forEach(log => {
					if ("TimeLogDetailedClaim" in log && log.TimeLogDetailedClaim) {
						claims = [
							...claims,
							...log.TimeLogDetailedClaim.filter(claim => claim.change_quote_id == changeOrderId)
						]
					}
				})
			}

			return claims
		},
		groupifyComponentClaims(claims,componentOrChangeOrder,isChangeOrder) {
			let groups = [], vm = this, elements
			let componentId = false

			if (isChangeOrder) {
				elements = this.getTotalElementsOnChangeOrder(componentOrChangeOrder,"Labour")
			}
			else {
				elements = this.getTotalElementsOnComponent(componentOrChangeOrder, "EmployeeClassification")

				componentId = componentOrChangeOrder.id
			}

			let jobCAs = {}
			try {
				jobCAs = JSON.parse(this.$store.project.collective_agreements_json)
			}
			catch (ex) {}

			// First, build groups from estimated hours in bid components (even if no claims exist)
			let uniqueClassificationIds = new Set()
			
			// If we have a componentId, use calc methods to find all classifications with estimated hours
			if (componentId && !isChangeOrder) {
				// Check all employee classifications to see which ones have estimated hours on this component
				if (vm.$store && vm.$store.employeeClassifications) {
					vm.$store.employeeClassifications.forEach(cl => {
						let hrs = this.calcClassificationEstimatedHours(cl.id, componentId)
						if (hrs > 0) {
							uniqueClassificationIds.add(cl.id)
						}
					})
				}
				
				// Also check elements as a fallback in case calc methods don't work
				if (uniqueClassificationIds.size == 0 && elements && elements.length > 0) {
					elements.forEach(element => {
						if (element.parsedFields && element.parsedFields.classification_id) {
							uniqueClassificationIds.add(element.parsedFields.classification_id)
						}
					})
				}
			} else if (elements && elements.length > 0) {
				// For change orders, get unique classification IDs from elements
				elements.forEach(element => {
					if (element.parsedFields && element.parsedFields.classification_id) {
						uniqueClassificationIds.add(element.parsedFields.classification_id)
					}
				})
			}

			// For each unique classification, calculate totals and build groups
			uniqueClassificationIds.forEach(classificationId => {
				// Find classification details
				let theClassification = null
				if (vm.$store && vm.$store.employeeClassifications) {
					theClassification = vm.$store.employeeClassifications.find(cl => cl.id == classificationId)
				}

				if (theClassification) {
					let estimatedHrs = 0
					let estimatedCost = 0

					// If we're calculating for a specific component, use the calc methods for accuracy
					if (componentId && !isChangeOrder) {
						estimatedHrs = this.calcClassificationEstimatedHours(classificationId, componentId)
						estimatedCost = this.calcClassificationEstimatedCost(classificationId, componentId)
					} else if (elements && elements.length > 0) {
						// For change orders, aggregate from elements
						elements
							.filter(el => el.parsedFields && el.parsedFields.classification_id == classificationId)
							.forEach(el => {
								let hrs = +el.qty || 0
								// Try to get rate from element, parsedFields, or classification
								let rate = +el.rate || 0
								if (!rate && el.parsedFields && el.parsedFields.rate) {
									rate = +el.parsedFields.rate
								}
								if (!rate && theClassification && theClassification.default_cost_hr) {
									rate = +theClassification.default_cost_hr
								}
								estimatedHrs += hrs
								estimatedCost += hrs * rate
							})
					}

					// Add if there are estimated hours (even if cost is 0, we want to show hours)
					if (estimatedHrs > 0) {
						// Find or create the group
						let groupId = theClassification.group_id || 'ungrouped'
						let theGroup = this.chargeOutGroups.find(group => group.id == groupId)
						
						if (!theGroup) {
							theGroup = { id: 'ungrouped', label: 'Ungrouped' }
						}

						let groupIndex = groups.findIndex(group => group.id == theGroup.id)

						if (groupIndex >= 0) {
							// Group exists, check if classification exists
							let classificationIndex = groups[groupIndex].classifications.findIndex(cl => cl.id == classificationId)

							if (classificationIndex < 0) {
								// Add new classification to existing group
								groups[groupIndex].classifications.push({
									id: classificationId,
									title: theClassification.title,
									estimatedHrs: estimatedHrs,
									hrsToDateTotal: 0,
									estimatedCost: estimatedCost,
									actualCost: 0,
									percentComplete: 0,
									overUnder: estimatedCost,
									hrsToDate: {
										regular_hours: 0,
										overtime_hours_15x: 0,
										overtime_hours_2x: 0,
										overtime_hours_25x: 0,
									}
								})
							}
						} else {
							// Create new group
							groups.push({
								id: theGroup.id,
								label: theGroup.label,
								estimatedHrs: estimatedHrs,
								hrsToDateTotal: 0,
								estimatedCost: estimatedCost,
								actualCost: 0,
								percentComplete: 0,
								overUnder: estimatedCost,
								classifications: [{
									id: classificationId,
									title: theClassification.title,
									estimatedHrs: estimatedHrs,
									hrsToDateTotal: 0,
									estimatedCost: estimatedCost,
									actualCost: 0,
									percentComplete: 0,
									overUnder: estimatedCost,
									hrsToDate: {
										regular_hours: 0,
										overtime_hours_15x: 0,
										overtime_hours_2x: 0,
										overtime_hours_25x: 0,
									}
								}],
								classificationsVisible: false
							})
						}
					}
				}
			})

			// Now merge in actual time log data from claims
			if (claims) {
				claims.forEach(claim => {

					let totalClaimCost = +claim.calculated_cost_regular_hours + +claim.calculated_cost_overtime_hours_15x + +claim.calculated_cost_overtime_hours_2x + +claim.calculated_cost_overtime_hours_25x

					let totalClaimHrs = +claim.regular_hours + +claim.overtime_hours_15x + +claim.overtime_hours_2x + +claim.overtime_hours_25x

					let log = vm.timeLogs.find(log => log.id == claim.timelog_id)
					if (!log) return

					let logClassification = {}
					try {
						logClassification = JSON.parse(log.classification_json)
					}
					catch (e) {}

					if (logClassification) {

						let classificationEstimatedCost = this.calcClassificationEstimatedCost(logClassification.id,componentId)
						let classificationEstimatedHrs = this.calcClassificationEstimatedHours(logClassification.id,componentId)

						let groupIndex = groups.findIndex(group => group.id == logClassification.group_id)

						if (groupIndex >= 0) {
							let classificationIndex = groups[groupIndex].classifications.findIndex(cl => cl.id == (logClassification.id || 'Unclassified'))

							if (classificationIndex >= 0) {
								// Update existing classification with actual data
								let hrsToDateTotalRaw = +totalClaimHrs + +groups[groupIndex].hrsToDateTotal

								groups[groupIndex].hrsToDateTotal = hrsToDateTotalRaw
								
								let actualCostRaw = +totalClaimCost + +groups[groupIndex].actualCost
								groups[groupIndex].actualCost = actualCostRaw.toFixed(2)

								let classHrsToDateTotalRaw = +groups[groupIndex].classifications[classificationIndex].hrsToDateTotal
								classHrsToDateTotalRaw += +totalClaimHrs

								groups[groupIndex].classifications[classificationIndex].hrsToDateTotal = classHrsToDateTotalRaw

								let classActualCostRaw = +groups[groupIndex].classifications[classificationIndex].actualCost
								classActualCostRaw += totalClaimCost

								groups[groupIndex].classifications[classificationIndex].actualCost = classActualCostRaw.toFixed(2)	

								groups[groupIndex].classifications[classificationIndex].percentComplete = groups[groupIndex].classifications[classificationIndex].actualCost / groups[groupIndex].classifications[classificationIndex].estimatedCost * 100	

								groups[groupIndex].classifications[classificationIndex].overUnder = groups[groupIndex].classifications[classificationIndex].estimatedCost - groups[groupIndex].classifications[classificationIndex].actualCost

								// Update hrsToDate breakdown
								groups[groupIndex].classifications[classificationIndex].hrsToDate.regular_hours += +claim.regular_hours
								groups[groupIndex].classifications[classificationIndex].hrsToDate.overtime_hours_15x += +claim.overtime_hours_15x
								groups[groupIndex].classifications[classificationIndex].hrsToDate.overtime_hours_2x += +claim.overtime_hours_2x
								groups[groupIndex].classifications[classificationIndex].hrsToDate.overtime_hours_25x += +claim.overtime_hours_25x
							}
							else {
								// Add classification that wasn't in estimate but has time logs
								groups[groupIndex].classifications.push({
									id: logClassification.id,
									title: logClassification.title,
									estimatedHrs: classificationEstimatedHrs,
									hrsToDateTotal: totalClaimHrs,
									estimatedCost: classificationEstimatedCost,
									actualCost: totalClaimCost,
									percentComplete: 0,
									overUnder: classificationEstimatedCost - totalClaimCost,
									hrsToDate: {
										regular_hours: claim.regular_hours,
										overtime_hours_15x: claim.overtime_hours_15x,
										overtime_hours_2x: claim.overtime_hours_2x,
										overtime_hours_25x: claim.overtime_hours_25x,
									}
								})
								groups[groupIndex].hrsToDateTotal = (groups[groupIndex].hrsToDateTotal || 0) + totalClaimHrs
								groups[groupIndex].actualCost = (+(groups[groupIndex].actualCost) || 0) + totalClaimCost
							}
						}
						else {
							//get group details from list of chargeout groups
							let theGroup = this.chargeOutGroups.find(group => group.id == logClassification.group_id)

							if (theGroup) {
								groups.push({
									id: theGroup.id,
									label: theGroup.label,
									estimatedHrs: classificationEstimatedHrs,
									hrsToDateTotal: totalClaimHrs,
									estimatedCost: classificationEstimatedCost,
									actualCost: totalClaimCost,
									percentComplete: 0,
									overUnder: classificationEstimatedCost - totalClaimCost,
									classifications: [{
										id: logClassification.id,
										title: logClassification.title,
										estimatedHrs: classificationEstimatedHrs,
										hrsToDateTotal: totalClaimHrs,
										estimatedCost: classificationEstimatedCost,
										actualCost: totalClaimCost,
										percentComplete: 0,
										overUnder: classificationEstimatedCost - totalClaimCost,
										hrsToDate: {
											regular_hours: claim.regular_hours,
											overtime_hours_15x: claim.overtime_hours_15x,
											overtime_hours_2x: claim.overtime_hours_2x,
											overtime_hours_25x: claim.overtime_hours_25x,
										}
									}],
									classificationsVisible: false
								})
							}
						}
					}
				})
			}

			groups = groups.map(group => {
				group.estimatedCost = group.classifications.reduce((acc,cl) => cl.estimatedCost + acc,0)
				group.estimatedHrs = group.classifications.reduce((acc,cl) => cl.estimatedHrs + acc,0)

				group.percentComplete = 0
				if (group.estimatedCost > 0 && group.actualCost > 0) {

					group.percentComplete = +group.actualCost / +group.estimatedCost * 100
				}

				group.overUnder = group.estimatedCost - group.actualCost

				return group
			})

			return groups
		},
		classifyComponentClaims(claims,componentOrChangeOrder,isChangeOrder) {
			let classifications = [], vm = this, elements

			if (isChangeOrder)
				elements = this.getTotalElementsOnChangeOrder(componentOrChangeOrder,"Labour")
			else
				elements = this.getTotalElementsOnComponent(componentOrChangeOrder, "EmployeeClassification")

			let jobCAs = {}
			try {
				jobCAs = JSON.parse(this.$store.project.collective_agreements_json)
			}
			catch (ex) {}

			if (claims) {
				claims.forEach(claim => {
					let log = vm.timeLogs.find(log => log.id == claim.timelog_id)

					let logClassification = {}
					try {
						logClassification = JSON.parse(log.classification_json)
					}
					catch (e) {}

					if (logClassification) {

						let collectiveAgreement = vm.$store.collectiveAgreements.find(ca => ca.id == jobCAs[logClassification.union_id])

						let payScales = []
						try {
							payScales = JSON.parse(collectiveAgreement.pay_scales)
						}
						catch (e) {}

						let classificationPayscale = payScales.find(ps => ps.classification_id == logClassification.id)

						let foundIndex = -1

						if ("id" in logClassification)
							foundIndex = classifications.findIndex(cl => cl.id == logClassification.id)
						else
							foundIndex = classifications.findIndex(cl => cl.title == "Unclassified")

						if (foundIndex == -1) {

							let title = "Unclassified"
							if ("title" in logClassification)
								title = logClassification.title

							let clId = 0
							if ("id" in logClassification)
								clId = logClassification.id

							let clToPush = {
								lineLabel: title,
								title,
								id: clId,
								regRaw: +claim.regular_hours,
								OT15Raw: +claim.overtime_hours_15x,
								OT2Raw: +claim.overtime_hours_2x,
								OT25Raw: +claim.overtime_hours_25x
							}

							let filteredElements = elements
								.filter(el => el.parsedFields.classification_id == logClassification.id)

							let estimatedHrs = filteredElements.reduce((acc,el) => acc + el.qty,0)

							clToPush.estimatedHrs = estimatedHrs

							let costAllowed = filteredElements.reduce((acc,el) => acc + (+el.qty * +el.rate),0)

							clToPush.costAllowed = costAllowed.toCurrency()					

							let actualCost = 0

							/*
							if (clToPush.id > 0) {

								if (classificationPayscale) {
									clToPush.payScale = classificationPayscale

									let regCostHr = "cost_hr" in classificationPayscale ? classificationPayscale.cost_hr : logClassification.default_cost_hr
									let ot15CostHr = "ot15_cost_hr" in classificationPayscale ? classificationPayscale.ot15_cost_hr : logClassification.ot15_cost_hr
									let ot2CostHr = "ot2_cost_hr" in classificationPayscale ? classificationPayscale.ot2_cost_hr : logClassification.ot2_cost_hr
									let ot25CostHr = "ot25_cost_hr" in classificationPayscale ? classificationPayscale.ot25_cost_hr : logClassification.ot25_cost_hr

									actualCost = 	(clToPush.regRaw * +regCostHr) + 
														(clToPush.OT15Raw * +ot15CostHr) + 
														(clToPush.OT2Raw * +ot2CostHr) + 
														(clToPush.OT25Raw * +ot25CostHr)
								}


								clToPush.actualCostRaw = actualCost
							}
							else {
								clToPush.actualCostRaw = actualCost
							}
							*/

							let costFields = ["calculated_cost_regular_hours","calculated_cost_overtime_hours_15x","calculated_cost_overtime_hours_2x","calculated_cost_overtime_hours_25x"]

							clToPush.actualCostRaw = 0
							costFields.forEach(key => {
								let parsedValue = +claim[key]

								if (!isNaN(parsedValue))
									clToPush.actualCostRaw += parsedValue
							})

							let percentCompleteRaw = 0
							if (clToPush.actualCostRaw != 0 && +clToPush.costAllowed != 0)
								percentCompleteRaw = clToPush.actualCostRaw / +clToPush.costAllowed * 100

							clToPush.percentComplete = vm.renderInlineProgressBar(percentCompleteRaw)

							let overUnder = +clToPush.costAllowed - clToPush.actualCostRaw

							let overUnderClass = ""
							if (overUnder > 0)
								overUnderClass = "text-success"
							else if (overUnder < 0)
								overUnderClass = "text-danger"

							clToPush.overUnder = "<span class='"+overUnderClass+"'>$"+overUnder.toCurrency()+"</span>"

							clToPush.actualCost = clToPush.actualCostRaw.toCurrency()

							clToPush.actualHrsRaw = clToPush.regRaw + clToPush.OT15Raw + clToPush.OT2Raw + clToPush.OT25Raw 

							clToPush.actualReg = clToPush.regRaw.toFixed(2)
							clToPush.actualOT15 = clToPush.OT15Raw.toFixed(2)
							clToPush.actualOT2 = clToPush.OT2Raw.toFixed(2)
							clToPush.actualOT25 = clToPush.OT25Raw.toFixed(2)

							clToPush.actualHrs = clToPush.actualHrsRaw.toFixed(2)

							classifications.push(clToPush)
						}
						else {
							
							classifications[foundIndex].regRaw += +claim.regular_hours
							classifications[foundIndex].OT15Raw += +claim.overtime_hours_15x
							classifications[foundIndex].OT2Raw += +claim.overtime_hours_2x
							classifications[foundIndex].OT25Raw += +claim.overtime_hours_25x

							/*
							let regCostHr = classificationPayscale && "cost_hr" in classificationPayscale ? classificationPayscale.cost_hr : logClassification.default_cost_hr
							let ot15CostHr = classificationPayscale && "ot15_cost_hr" in classificationPayscale ? classificationPayscale.ot15_cost_hr : logClassification.ot15_cost_hr
							let ot2CostHr = classificationPayscale && "ot2_cost_hr" in classificationPayscale ? classificationPayscale.ot2_cost_hr : logClassification.ot2_cost_hr
							let ot25CostHr = classificationPayscale && "ot25_cost_hr" in classificationPayscale ? classificationPayscale.ot25_cost_hr : logClassification.ot25_cost_hr

							let actualCost = 	(classifications[foundIndex].regRaw * +regCostHr) + 
												(classifications[foundIndex].OT15Raw * +ot15CostHr) + 
												(classifications[foundIndex].OT2Raw * +ot2CostHr) + 
												(classifications[foundIndex].OT25Raw * +ot25CostHr)


							classifications[foundIndex].actualCostRaw += actualCost
							*/

							let costFields = ["calculated_cost_regular_hours","calculated_cost_overtime_hours_15x","calculated_cost_overtime_hours_2x","calculated_cost_overtime_hours_25x"]

							costFields.forEach(key => {
								let parsedValue = +claim[key]

								if (!isNaN(parsedValue)) {

									classifications[foundIndex].actualCostRaw += parsedValue
								}
							})

							let percentCompleteRaw = 0
							if (classifications[foundIndex].actualCostRaw != 0 && +classifications[foundIndex].costAllowed != 0)
								percentCompleteRaw = classifications[foundIndex].actualCostRaw / +classifications[foundIndex].costAllowed * 100

							classifications[foundIndex].percentComplete = vm.renderInlineProgressBar(percentCompleteRaw)

							let overUnder = +classifications[foundIndex].costAllowed - classifications[foundIndex].actualCostRaw

							let overUnderClass = ""
							if (overUnder > 0)
								overUnderClass = "text-success"
							else if (overUnder < 0)
								overUnderClass = "text-danger"

							classifications[foundIndex].overUnder = "<span class='"+overUnderClass+"'>$"+overUnder.toCurrency()+"</span>"

							classifications[foundIndex].actualCost = classifications[foundIndex].actualCostRaw.toCurrency()
							classifications[foundIndex].actualHrs += classifications[foundIndex].regRaw + classifications[foundIndex].OT15Raw + classifications[foundIndex].OT2Raw + classifications[foundIndex].OT25Raw

							classifications[foundIndex].actualReg = classifications[foundIndex].regRaw
							classifications[foundIndex].actualOT15 = classifications[foundIndex].OT15Raw
							classifications[foundIndex].actualOT2 = classifications[foundIndex].OT2Raw
							classifications[foundIndex].actualOT25 = classifications[foundIndex].OT25Raw

							classifications[foundIndex].actualHrs = classifications[foundIndex].actualHrsRaw.toFixed(2)
						}
					}
				})
			}

			return classifications
		},
		fetchAllTimeLogPages(spinner) {
			let vm = this

			let page = 1

			this.timeLogFetchCompleted = false
			this.timeLogReportGeneratingInProgress = true

			if (spinner)
				this.spinner(true,this.timeLogFetchProgress+"%")

			return new Promise((resolve,reject) => {

				vm.fetchTimeLogPage(page).then(response => {

					let numPages = response.meta.num_pages

					let cntResolves = 1;

					vm.timeLogs = response.data

					if (numPages > 1) {

						for (var p = 2; p <= numPages; p++) {
							vm.fetchTimeLogPage(p).then(response => {

								cntResolves++

								vm.timeLogFetchProgress = Math.floor(cntResolves / numPages * 100)

								if (spinner)
									vm.spinner(true,vm.timeLogFetchProgress+"%")

								if (response)
									vm.timeLogs = vm.timeLogs.concat(response.data)

								if (vm.timeLogFetchProgress >= 100) {
									//COMPLETE

									if (spinner)
										vm.spinner(false)

									vm.timeLogFetchCompleted = true

									vm.$store.project.TimeLog = vm.timeLogs

									resolve(vm.$store.project.TimeLog)
								}
							})
						}
					}
					else {

						if (spinner)
							vm.spinner(false)

						vm.timeLogFetchCompleted = true

						vm.$store.project.TimeLog = vm.timeLogs

						vm.timeLogFetchProgress = 100
						resolve(vm.$store.project.TimeLog)
					}
				})
			})
			
		},
		fetchTimeLogPage(page) {
			let vm = this

			let include = [
				{
					model: "User",
					include: [{model:"EmployeeClassification",fields:["id","title","classification_id","default_cost_hr","ot15_cost_hr","ot2_cost_hr","ot25_cost_hr","union_id"]}],
					fields: ["id","slug","first_name","last_name"]
				}
			]

			if (this.$store.project.detailed_timelogs == 1) 
				include.push("TimeLogDetailedClaim")

			let params = {
				filters: [
					["job_id",this.$store.project.id]
				],
				include,
				fields: ["id","slug","regular_hours","overtime_hours_15x","overtime_hours_2x","overtime_hours_25x","job_id","service_id","collective_agreement_id","classification_json","calculated_cost","submitted_by"],
				page: page
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("TimeLog/get",params).then(response => {

					resolve(response)
				})
			})
		},
		fetchChangeOrders() {
			let vm = this

			let params = {
				filters: [
					["job_id", this.$store.project.id],
					["hide_from_detailed_reporting", 0]
				],
				include: [
					"JobChangeOrderObject"
				]
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("JobChangeOrder/get",params).then(response => {

					if (response.success)
						vm.changeOrders = response.data

					resolve(response)
				})
			})
		},
		fetchChargeOutGroups() {
			let vm = this

			return new Promise((resolve,reject) => {
				vm.getJSON("ClassificationGroup/get").then(response => {
					if (response.success)
						vm.chargeOutGroups = response.data

					resolve(response)
				})
			})
		},
		fetchData() {
			let vm = this

			let promises = [], bidPromiseIndex = false, reportBeingFetched = false
			if ("slug" in this.$store.project && this.$store.project.slug == this.$route.params.id) {

				if (!this.dataFetched /* && this.reportNeedsFetching()*/) {
					reportBeingFetched = true

					promises = [
						this.fetchAllTimeLogPages(true),
						//this.fetchEstimate(this.$route.params.id),
						this.getJSON("TimeLogSetting/get"),
						this.getJSON("CollectiveAgreement/get",true), //outputting errors on just one resource for Freemium Tier error message
						this.fetchActiveBid({
							projectId: vm.$store.project.id
						}),
						this.fetchChangeOrders(),
						this.fetchChargeOutGroups(),
						this.getJSON("EmployeeClassification/get")
					]
				}

				Promise.all(promises).then(responses => {

					if (reportBeingFetched) {
						vm.$store.timeLogSettings = responses[1].data[0]

						vm.$store.collectiveAgreements = responses[2].data

						

						//vm.classifyTimeLogs()

						/*
						vm.mergeEstimate()
					
						localStorage.labourEstimate = JSON.stringify(vm.classificationsInEstimate)
						localStorage.labourEstimateCachedAt = vm.moment().format("YYYY-MM-DD HH:mm")
						localStorage.labourEstimateJobSlug = vm.$route.params.id
						*/

						vm.bid = responses[3]

						vm.$store.employeeClassifications = responses[6].data

						vm.fetchAllComponents(vm.bid.id,[
							{model: 'JobBidComponentObject',filters:[["type","EmployeeClassification"]]},
							"TimeLogDetailedClaim"
						]).then(response => {
							vm.renderChargeOutGroupsFromBid()

							vm.dataFetched = true
						})

						//vm.detailedTimelogClaims = responses[bidPromiseIndex + 1].data

						

					}
					
				})
			}
		}
	},
	created() {
		this.fetchData()
	}
}
</script>

<style scoped>
	.charge-out-group-row {
		font-weight: 600;
	}

	.hour-type-row {
		font-size: 0.9em;
	}
</style>